<template>
    <b-container>
        <b-row>
            <b-col cols="12" v-for="(item, index) in options" :key="index">
                <div class="inline-box">                   
                        <b-img  class="inline-element"
                                alt="image" 
                                rounded="circle"
                                v-bind="item.ImageUrl == null ? propsImageBlank : propsImage" 
                                :src="item.ImageUrl"/>
                    
                        <a id="link-reference"
                           class="inline-element" 
                           :href="item.PdfUrl" 
                           target="_blank">
                           {{item.Name}}</a>
                </div>
                <hr class="m-7-0"/> 
            </b-col>
        </b-row>
    </b-container>       
</template>

<script>
import '@/assets/styles/client/help/helpViewer.css'

export default {
    model:{
        prop: 'value',
        event: 'update'
    },
    props:{
        value: Array,
        options:{
            type: Array,
            default: null
        }
    },
    computed: {
        references: function() {
            return this.options;
        }
    },
    data: function() {
        return {
            propsImageBlank: { blank: true, blankColor: '#777', width: 50, height: 50, class: 'm1' },
            propsImage: {  width: 50, height: 50, class: 'm1' }
        };
    }
}
</script>